var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCritical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.439,
    height: 73.495,
    viewBox: "0 0 63.439 73.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10156",
    "data-name": "Grupo 10156",
    transform: "translate(-3642.313 -2888.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7141",
    "data-name": "Trazado 7141",
    d: "M171.419,128.794h33.822a3.756,3.756,0,0,0,3.752-3.752v-2.35c9.365-6.423,10.64-12.833,10.689-13.1a.909.909,0,0,0-.894-1.073h-9.8V99.331c9.365-6.422,10.64-12.833,10.689-13.1a.909.909,0,0,0-.894-1.073h-9.795V75.971c9.365-6.422,10.64-12.833,10.689-13.1a.909.909,0,0,0-.894-1.073h-9.795V59.751A3.756,3.756,0,0,0,205.24,56H171.419a3.756,3.756,0,0,0-3.752,3.752v2.041h-9.794a.909.909,0,0,0-.894,1.073c.05.272,1.324,6.683,10.689,13.1v9.183h-9.795a.909.909,0,0,0-.894,1.073c.049.272,1.324,6.682,10.689,13.1v9.183h-9.795a.909.909,0,0,0-.894,1.073c.049.272,1.324,6.682,10.689,13.1v2.35a3.755,3.755,0,0,0,3.751,3.752Zm46.13-18.46c-.725,1.874-2.845,5.935-8.557,10.133V110.334Zm0-23.361c-.725,1.874-2.845,5.935-8.557,10.133V86.973Zm0-23.361c-.725,1.874-2.845,5.936-8.557,10.133V63.612Zm-48.062-3.861a1.934,1.934,0,0,1,1.932-1.932h33.822a1.934,1.934,0,0,1,1.932,1.932v65.291a1.935,1.935,0,0,1-1.933,1.932H171.419a1.934,1.934,0,0,1-1.932-1.932Zm-10.376,3.861h8.557V73.745C161.954,69.546,159.834,65.483,159.111,63.612Zm0,23.361h8.557V97.1C161.954,92.907,159.834,88.844,159.111,86.973Zm0,23.361h8.557v10.133C161.954,116.268,159.834,112.206,159.111,110.334Z",
    transform: "translate(3485.703 2833)",
    fill: "#b1ca56",
    stroke: "#b1ca56",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7142",
    "data-name": "Trazado 7142",
    d: "M305.664,110.968a8.6,8.6,0,1,0-8.6-8.6A8.611,8.611,0,0,0,305.664,110.968Zm0-15.384a6.782,6.782,0,1,1-6.782,6.782A6.79,6.79,0,0,1,305.664,95.584Z",
    transform: "translate(3368.368 2801.372)",
    fill: "#b1ca56",
    stroke: "#b1ca56",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7143",
    "data-name": "Trazado 7143",
    d: "M305.664,244.268a8.6,8.6,0,1,0-8.6-8.6A8.611,8.611,0,0,0,305.664,244.268Zm0-15.384a6.782,6.782,0,1,1-6.782,6.782A6.79,6.79,0,0,1,305.664,228.884Z",
    transform: "translate(3368.368 2689.732)",
    fill: "#b1ca56",
    stroke: "#b1ca56",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7144",
    "data-name": "Trazado 7144",
    d: "M305.664,377.568a8.6,8.6,0,1,0-8.6-8.6A8.611,8.611,0,0,0,305.664,377.568Zm0-15.384a6.782,6.782,0,1,1-6.782,6.782A6.79,6.79,0,0,1,305.664,362.184Z",
    transform: "translate(3368.368 2578.092)",
    fill: "#b1ca56",
    stroke: "#b1ca56",
    strokeWidth: 0.7
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCritical);
export default __webpack_public_path__ + "static/media/critical.41d08e52ac2ff94d759142b293b416ff.svg";
export { ForwardRef as ReactComponent };